<template>
  <div class="summation">
    <a-row style="margin-bottom:24px;" v-for="(item,index) in summationLayout.contents" :key="index">
      <a-col :xs="6" :sm="4">
        <div class="label">{{item.label}}：</div>
      </a-col>
      <a-col :xs="10" :sm="10">{{fromDetail?allParams[item.field]:(Number(fieldObj[item.field]).toFixed(2) + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,') || 0.00 }}
        <span v-if="!fromDetail">（自动计算）</span>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { tileParams, moneyToNumValue } from '../utils/tools.js';

export default {
  components: {},
  props: {
    layout: Object,
    params: Object,
    allParams: Object,
    fromDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      paramsArr: [],
      summationLayout: _.cloneDeep(this.layout),
      fieldObj: {},
    };
  },
  computed: {},

  methods: {
    countFieldArr(params) {
      let arr = _.cloneDeep(params);
      this.paramsArr = [];
      this.layoutArr = [];
      tileParams(arr, this.paramsArr);
      this.summationLayout.contents.forEach(item => {
        const newArr = this.paramsArr.filter(child => {
          return Object.keys(child)[0] === item.dependsParams;
        });
        let sum = 0;
        newArr.forEach(r => {
          let dependsParams =
            typeof r[item.dependsParams] === 'string'
              ? moneyToNumValue(r[item.dependsParams])
              : r[item.dependsParams];
          if (r[item.dependsParams]) sum = Number(dependsParams) + sum;
        });
        this.$set(this.fieldObj, item.field, sum.toFixed(2));
        // this.fieldObj.fieldType = 'summation';
        this.$emit('changed-fields', this.fieldObj);
      });
      return this.fieldObj;
    },
  },
  created() {},
  watch: {
    allParams: {
      handler(val) {
        this.fieldArr = this.countFieldArr(val);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="less">
.summation {
  .label {
    text-align: right;
  }
}
</style>
